const reservedCreateUserAttempts = new Set<string>()

export function buildCreateUserAttemptKey({
  email,
  firstName,
}: {
  email: string | null
  firstName: string | null
}) {
  return `resolved:${email ?? ''}:${firstName ?? ''}`
}

export function reserveCreateUserAttempt(attemptKey: string): boolean {
  if (reservedCreateUserAttempts.has(attemptKey)) {
    return false
  }

  reservedCreateUserAttempts.add(attemptKey)
  return true
}

export function clearReservedCreateUserAttempt(attemptKey: string): void {
  reservedCreateUserAttempts.delete(attemptKey)
}
